import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_CONDITIONAL_KICKSTART_CONFIG = defineFcm('conditional_kickstart_config')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				impressions: { type: 'number' },
				signature_threshold: {
					type: 'enum',
					values: ['5', '10', '25', '50', '100', '250', '500'] as const,
					normalizer: (value) => Number(value),
				},
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-starfish',
		scope: ['petition-service', 'QAA'],
		context: 'Conditional Kickstart',
		description: `Feature toggle + free promotion config for the Conditional Kickstart in the Starter Onboarding flow. 
			- This fcm should be configured for country only
			- signature_threshold: Should be one of the supported milestone intervals: '5', '10', '25', '50', '100', '250', '500'`,
		import: false,
		template: {
			enabled: false,
			impressions: 0,
			signature_threshold: '5',
		},
		supportedGroups: { countries: true },
	});
